import React from "react";

import { toastError } from "../../../shared/helpers";

import { PrimaryButton } from "../../atoms/Buttons";

import { P } from "../../atoms/Texts";
import ModalHolder from "../../molecules/ModalHolder";

const DeleteServiceModal = ({ closeModal, serviceId }) => {
  const onDeleteService = () => {
    toastError("Can not perform this action in Demo mode");
  };

  return (
    <ModalHolder closeModal={closeModal} header="Delete Service">
      <section className="py-4 md:py-6">
        <P className="mb-4">
          Deleting this service is irreversible, are you certain of this action?
        </P>
        <PrimaryButton.Danger onClick={onDeleteService}>
          "Delete Service"
        </PrimaryButton.Danger>
      </section>
    </ModalHolder>
  );
};

export default DeleteServiceModal;
